import properties from '../modules/ajio-util/properties';
import { getHostName } from './sisUtils';

export function getRedirectURI(queryObj, searchObj) {
  let redirectURI = '/';
  const referrer = queryObj.referrer
    ? queryObj.referrer
    : searchObj.referrer
    ? searchObj.referrer
    : undefined;
  redirectURI = referrer ? redirectURI + referrer : redirectURI;

  if (redirectURI.indexOf('http') > -1) {
    redirectURI = redirectURI.slice(1);
  }
  return redirectURI;
}

export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export function isPhoneUserAgent() {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const { userAgent } = navigator;
    if (userAgent.includes('phonepe-webview')) {
      return true;
    }
  }
  return false;
}

export function getGoogleAuthUrl() {
  const { location: { origin = '' } = {} } = window;
  const storeName = getHostName(origin);
  const googleClientId = properties.getProperty('googleClientId');
  const googleAuthRedirectURI =
    storeName == '' || storeName == 'ajio'
      ? `${properties.getProperty('parentUrl')}/login/google-auth-redirect`
      : `${properties
          .getProperty('luxeGoogleUrl')
          .replace('luxe', storeName)}/login/google-auth-redirect`;

  const url = `https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile&redirect_uri=${googleAuthRedirectURI}&client_id=${googleClientId}&response_type=code&prompt=select_account&include_granted_scopes=true&access_type=offline`;
  return url;
}
